/* Stel je vloer samen - wizard logica */
(function () {
  var root = document.querySelector('[data-vw]');
  if (!root) return;

  var cfg = JSON.parse(root.querySelector('[data-vw-config]').textContent);

  var FLOW = ['patroon', 'kleur', 'm2'];
  if (cfg.stappen.ondergrond) FLOW.push('ondergrond');
  if (cfg.stappen.plinten) FLOW.push('plinten');
  if (cfg.stappen.legservice) FLOW.push('legservice');
  if (cfg.stappen.planning) FLOW.push('planning');
  FLOW.push('locatie', 'contact');

  var NAMEN = {
    patroon: 'Legpatroon', kleur: 'Jouw kleur', m2: 'Oppervlakte', ondergrond: 'Ondergrond', plinten: 'Plinten',
    legservice: 'Leggen', planning: 'Planning', locatie: 'Locatie', contact: 'Voorstel ontvangen'
  };

  var state = {};
  var bijlagen = { plattegrond: [], fotos: [] };
  var OPSLAG = 'vw-aanvraag-v1';

  try {
    var bewaard = JSON.parse(localStorage.getItem(OPSLAG) || '{}');
    if (bewaard && typeof bewaard === 'object') state = bewaard;
    // Oppervlakte nooit voorinvullen: de klant meet opnieuw.
    delete state.m2;
  } catch (e) { state = {}; }

  function bewaar() {
    try { localStorage.setItem(OPSLAG, JSON.stringify(state)); } catch (e) {}
  }

  function meet(naam, extra) {
    if (!cfg.ga) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: naam }, extra || {}));
  }

  function el(sel) { return root.querySelector(sel); }
  function alle(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function stapEl(id) { return el('[data-step="' + id + '"]'); }

  function getal(v) {
    var n = parseFloat(String(v || '').replace(',', '.'));
    return isNaN(n) ? 0 : n;
  }

  function vloerVan(id) {
    for (var i = 0; i < cfg.vloeren.length; i++) if (cfg.vloeren[i].id === id) return cfg.vloeren[i];
    return null;
  }

  /* ---- navigatie ---- */
  var huidig = -1; // -1 = landing
  var eersteWeergave = true;

  /* Scroll naar de bovenkant van de wizard, met ruimte voor de sticky header.
     Te veel ruimte = kop iets lager in beeld; te weinig = kop verstopt achter de header. */
  function scrollNaarWizard() {
    var y = root.getBoundingClientRect().top + window.pageYOffset;
    var ruimte = window.innerWidth < 768 ? 250 : 160;
    window.scrollTo({ top: Math.max(y - ruimte, 0), behavior: 'smooth' });
  }

  function toon(idx) {
    alle('.vw-step').forEach(function (s) { s.classList.remove('actief'); });
    var id = idx === -1 ? 'landing' : (idx >= FLOW.length ? 'klaar' : FLOW[idx]);
    var s = stapEl(id);
    if (s) s.classList.add('actief');

    var voortgang = el('[data-vw-voortgang]');
    if (voortgang) voortgang.style.display = (idx >= 0 && idx < FLOW.length) ? '' : 'none';
    if (idx >= 0 && idx < FLOW.length) {
      el('[data-vw-stapnaam]').textContent = 'Stap ' + (idx + 1) + ' van ' + FLOW.length + ' · ' + NAMEN[id];
      var rest = (FLOW.length - idx - 1) * 10 + 5;
      el('[data-vw-resttijd]').textContent = idx === FLOW.length - 1 ? 'bijna klaar' : 'nog ±' + rest + ' sec';
      el('.vw-balk i').style.width = Math.round(((idx + 1) / FLOW.length) * 100) + '%';
    }
    huidig = idx;
    if (!eersteWeergave) scrollNaarWizard();
    eersteWeergave = false;
    vulSamenvatting();
    var rail = el('[data-vw-samenvatting]');
    if (rail && (idx < 0 || idx >= FLOW.length)) rail.style.display = 'none';
    if (id === 'kleur') filterKleuren();
    if (id === 'm2') updateSnijRegel();
    if (id === 'plinten') prefillPlint();
    meet('vw_stap', { vw_stap: id, vw_stapnummer: idx + 1 });
  }

  function fout(stapId, tekst) {
    var f = stapEl(stapId).querySelector('.vw-foutmelding');
    if (f) { f.textContent = tekst || ''; f.style.display = tekst ? 'block' : 'none'; }
  }

  function valideer(id) {
    fout(id, '');
    if (id === 'patroon' && !state.patroon) return 'Kies eerst een legpatroon.';
    if (id === 'kleur' && !state.vloer) return 'Kies eerst een vloer.';
    if (id === 'm2') {
      var m = getal(el('[name="vw-m2"]').value);
      if (m <= 0) return 'Vul je totale oppervlakte in.';
      if (m > 2000) return 'Dat is wel heel veel vloer. Klopt het aantal m²?';
      state.m2 = m;
    }
    if (id === 'ondergrond') {
      if (!state.vloerverwarming) return 'Geef aan of er vloerverwarming ligt.';
      if (!state.ondervloer) return 'Kies wat er nu op de vloer ligt.';
    }
    if (id === 'plinten') {
      if (cfg.plintenInbegrepen) state.plinten = 'ja';
      if (!state.plinten) return 'Kies of je plinten wilt.';
      if (state.plinten === 'ja') {
        if (el('input[name="vw-plintkeuze"]') && !state.plintKeuze) return 'Kies welke plint je wilt.';
        var pm = getal(el('[name="vw-plintmeters"]').value);
        if (pm <= 0) return 'Vul de strekkende meters plint in.';
        state.plintMeters = pm;
        if (!state.plintKeuze && !state.plintKleur) state.plintKleur = 'Wit';
      }
    }
    if (id === 'legservice' && !state.legservice) return 'Kies of wij de vloer leggen.';
    if (id === 'planning' && !state.planning) return 'Kies wat voor jou geldt.';
    if (id === 'locatie') {
      var plaats = (el('[name="vw-plaats"]').value || '').trim();
      if (!plaats) return 'Vul de plaats in waar de vloer komt.';
      state.plaats = plaats;
    }
    if (id === 'contact') {
      state.naam = (el('[name="vw-naam"]').value || '').trim();
      state.email = (el('[name="vw-email"]').value || '').trim();
      state.telefoon = (el('[name="vw-telefoon"]').value || '').trim();
      if (!state.naam) return 'Vul je naam in.';
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(state.email)) return 'Vul een geldig e-mailadres in.';
      if (state.telefoon.replace(/\D/g, '').length < 8) return 'Vul een geldig telefoonnummer in.';
    }
    return '';
  }

  function volgende() {
    var id = FLOW[huidig];
    var melding = valideer(id);
    if (melding) { fout(id, melding); return; }
    bewaar();
    if (huidig === FLOW.length - 1) { verstuur(); return; }
    toon(huidig + 1);
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-vw-start]')) { e.preventDefault(); toon(0); }
    if (e.target.closest('[data-vw-volgende]')) { e.preventDefault(); volgende(); }
    var kn = e.target.closest('[data-vw-sam-toggle]');
    if (kn) {
      e.preventDefault();
      var sam = el('[data-vw-samenvatting]');
      var open = sam.classList.toggle('open');
      kn.setAttribute('aria-expanded', open ? 'true' : 'false');
      kn.textContent = open ? 'Verberg' : 'Details';
    }
    if (e.target.closest('[data-vw-terug]')) { e.preventDefault(); toon(Math.max(huidig - 1, huidig === 0 ? -1 : 0)); }
    if (e.target.closest('[data-vw-naar-patroon]')) { e.preventDefault(); toon(0); }
    if (e.target.closest('[data-vw-twijfel]')) { e.preventDefault(); delete state.patroon; bewaar(); toon(1); }
  });

  function patroonLabel() {
    var p = state.patroon;
    if (!p) { var v = vloerVan(state.vloer); p = v ? v.patroon : ''; }
    return p === 'visgraat' ? 'Visgraat' : (p ? 'Rechte plank' : '');
  }

  /* ---- keuzekaarten ---- */
  function bindKeuze(veld, stateKey) {
    alle('input[name="' + veld + '"]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        state[stateKey] = inp.value;
        alle('input[name="' + veld + '"]').forEach(function (a) {
          a.closest('.vw-kaart, .vw-kchip') && a.closest('.vw-kaart, .vw-kchip').classList.toggle('gekozen', a.checked);
        });
        if (veld === 'vw-plinten') togglePlintVelden();
        bewaar();
      });
      if (state[stateKey] && inp.value === state[stateKey]) {
        inp.checked = true;
        inp.closest('.vw-kaart, .vw-kchip') && inp.closest('.vw-kaart, .vw-kchip').classList.add('gekozen');
      }
    });
  }

  bindKeuze('vw-patroon', 'patroon');
  bindKeuze('vw-vloer', 'vloer');
  bindKeuze('vw-vloerverwarming', 'vloerverwarming');
  bindKeuze('vw-ondervloer', 'ondervloer');
  bindKeuze('vw-plinten', 'plinten');
  bindKeuze('vw-plintkleur', 'plintKleur');
  bindKeuze('vw-plintkeuze', 'plintKeuze');
  bindKeuze('vw-legservice', 'legservice');
  bindKeuze('vw-planning', 'planning');

  function filterKleuren() {
    var sub = el('[data-vw-kleur-sub]');
    if (sub) sub.textContent = state.patroon ? patroonLabel() + ' · ons aanbod' : 'Alle patronen en kleuren';
    var past = 0;
    alle('[data-vloer-patroon]').forEach(function (k) {
      var toonKaart = !state.patroon || k.getAttribute('data-vloer-patroon') === state.patroon;
      k.style.display = toonKaart ? '' : 'none';
      if (toonKaart) past++;
      if (!toonKaart) {
        var inp = k.querySelector('input');
        if (inp && inp.checked) { inp.checked = false; k.classList.remove('gekozen'); delete state.vloer; }
      }
    });
    var leeg = el('[data-vw-geen-vloeren]');
    if (leeg) leeg.style.display = past === 0 ? 'block' : 'none';
  }

  /* ---- m2 en snijverlies ---- */
  function snijAan() { return state.snijverliesAan !== false; }
  function snijPct() {
    var patroon = state.patroon;
    if (!patroon && state.vloer) {
      var v = vloerVan(state.vloer);
      if (v) patroon = v.patroon;
    }
    return patroon === 'visgraat' ? (cfg.snijverliesVisgraat || 15) : cfg.snijverlies;
  }
  function m2Totaal() {
    var m = getal(state.m2);
    if (m <= 0) return 0;
    return snijAan() ? Math.ceil(m * (1 + snijPct() / 100)) : Math.ceil(m);
  }
  function updateSnijRegel() {
    var pctEl = el('[data-vw-snijpct]');
    if (pctEl) pctEl.textContent = snijPct();
    var regel = el('[data-vw-snijverlies]');
    if (!regel) return;
    if (!(getal(state.m2) > 0)) { regel.textContent = ''; return; }
    regel.textContent = snijAan()
      ? 'Met ' + snijPct() + '% snijverlies bestellen we ±' + m2Totaal() + ' m² voor je'
      : 'Wij rekenen met precies ' + m2Totaal() + ' m²';
  }
  var m2Input = el('[name="vw-m2"]');
  if (m2Input) {
    m2Input.addEventListener('input', function () {
      state.m2 = getal(m2Input.value);
      updateSnijRegel();
      vulSamenvatting();
      bewaar();
    });
  }
  var svToggle = el('input[name="vw-snijverlies"]');
  if (svToggle) {
    var svLabel = svToggle.closest('.vw-toggle');
    svToggle.checked = snijAan();
    if (svLabel) svLabel.classList.toggle('aan', svToggle.checked);
    svToggle.addEventListener('change', function () {
      state.snijverliesAan = svToggle.checked;
      if (svLabel) svLabel.classList.toggle('aan', svToggle.checked);
      updateSnijRegel();
      bewaar();
    });
  }
  updateSnijRegel();

  /* ---- plinten ---- */
  function togglePlintVelden() {
    var tonen = cfg.plintenInbegrepen || state.plinten === 'ja';
    alle('[data-vw-plintvelden]').forEach(function (v) { v.style.display = tonen ? '' : 'none'; });
  }
  function prefillPlint() {
    togglePlintVelden();
    var inp = el('[name="vw-plintmeters"]');
    if (inp && state.plintMeters) inp.value = state.plintMeters;
  }

  /* ---- uploads ---- */
  function bindOptie(checkboxNaam, stateKey) {
    var inp = el('input[name="' + checkboxNaam + '"]');
    if (!inp) return;
    inp.addEventListener('change', function () {
      inp.closest('.vw-optie').classList.toggle('gekozen', inp.checked);
      state[stateKey] = inp.checked;
      bewaar();
    });
    if (state[stateKey]) {
      inp.checked = true;
      inp.closest('.vw-optie').classList.add('gekozen');
    }
  }
  bindOptie('vw-heeft-plattegrond', 'wilPlattegrond');
  bindOptie('vw-wil-fotos', 'wilFotos');

  // Zonder endpoint kan de browser geen bestanden mailen: dan lopen bijlagen via WhatsApp na afloop.
  if (!cfg.endpoint) {
    alle('.vw-upload').forEach(function (u) {
      u.innerHTML = '<p class="vw-tip">Top. Na het versturen krijg je direct een WhatsApp-knop om dit mee te sturen.</p>';
    });
  }

  var MAX_PER_BESTAND = 2.5 * 1024 * 1024;
  var MAX_TOTAAL_B64 = 3 * 1024 * 1024;

  function comprimeerAfbeelding(file) {
    return new Promise(function (resolve) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        var max = 1600;
        var schaal = Math.min(1, max / Math.max(img.width, img.height));
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * schaal);
        c.height = Math.round(img.height * schaal);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        var dataUrl = c.toDataURL('image/jpeg', 0.8);
        resolve({ naam: file.name.replace(/\.[^.]+$/, '') + '.jpg', data: dataUrl.split(',')[1] });
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(null); };
      img.src = url;
    });
  }

  function leesBestand(file) {
    return new Promise(function (resolve) {
      var r = new FileReader();
      r.onload = function () { resolve({ naam: file.name, data: String(r.result).split(',')[1] }); };
      r.onerror = function () { resolve(null); };
      r.readAsDataURL(file);
    });
  }

  function bindUpload(inputNaam, doel, lijstSel) {
    var inp = el('input[name="' + inputNaam + '"]');
    if (!inp) return;
    inp.addEventListener('change', function () {
      var lijst = el(lijstSel);
      lijst.innerHTML = '';
      bijlagen[doel] = [];
      var files = Array.prototype.slice.call(inp.files || []).slice(0, 4);
      files.forEach(function (file) {
        var pdf = /pdf$/i.test(file.type) || /\.pdf$/i.test(file.name);
        var verwerk;
        if (pdf) {
          if (file.size > MAX_PER_BESTAND) {
            lijst.insertAdjacentHTML('beforeend', '<span>' + file.name + ' is te groot (max 2,5 MB). Stuur hem via WhatsApp.</span>');
            return;
          }
          verwerk = leesBestand(file);
        } else if (/^image\//.test(file.type)) {
          verwerk = comprimeerAfbeelding(file);
        } else {
          lijst.insertAdjacentHTML('beforeend', '<span>' + file.name + ': alleen foto’s of pdf.</span>');
          return;
        }
        verwerk.then(function (res) {
          if (!res) return;
          bijlagen[doel].push(res);
          lijst.insertAdjacentHTML('beforeend', '<span><b>✓</b> ' + res.naam + '</span>');
        });
      });
    });
  }
  bindUpload('vw-plattegrond', 'plattegrond', '[data-vw-lijst-plattegrond]');
  bindUpload('vw-fotos', 'fotos', '[data-vw-lijst-fotos]');

  /* ---- samenvatting ---- */
  function plintTekst() {
    if (!cfg.stappen.plinten) return '';
    if (!cfg.plintenInbegrepen && state.plinten !== 'ja') return 'Nee';
    var welke = state.plintKeuze || (state.plintKleur || 'wit').toLowerCase();
    return welke + ', ' + (state.plintMeters || '?') + ' m';
  }

  function bedrag(n) {
    var s = n.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '\u20ac ' + s.replace(',00', ',-');
  }

  function prijsPerM2() {
    var p = cfg.prijzen || {};
    var v = vloerVan(state.vloer);
    var patroon = state.patroon || (v ? v.patroon : '');
    var ruw = patroon === 'visgraat' ? p.visgraat : p.recht;
    if (!ruw) ruw = p.recht || p.visgraat;
    var n = parseFloat(String(ruw || '').replace(/[^0-9,.]/g, '').replace(',', '.'));
    return isFinite(n) && n > 0 ? n : 0;
  }

  function vulPrijs() {
    var vak = el('[data-vw-prijs]');
    if (!vak) return;
    var per = prijsPerM2();
    var toel = el('[data-vw-prijs-toelichting]');
    el('[data-vw-prijs-label]').textContent = (cfg.prijzen && cfg.prijzen.label) || 'All-in indicatie';
    function mini(tekst) { alle('[data-vw-mini-prijs]').forEach(function (e) { e.textContent = tekst; }); }
    if (!per) { vak.style.display = 'none'; mini(''); return; }
    vak.style.display = '';
    if (state.m2 > 0) {
      el('[data-vw-prijs-bedrag]').textContent = bedrag(state.m2 * per);
      mini(bedrag(state.m2 * per));
      var drempel = (cfg.prijzen && cfg.prijzen.vanafM2) || 0;
      var basis = state.m2 + ' m\u00b2 vloeroppervlak \u00d7 ' + bedrag(per) + ' per m\u00b2';
      toel.textContent = (drempel && state.m2 < drempel)
        ? basis + '. De actieprijs geldt vanaf ' + drempel + ' m\u00b2, daaronder komt er een toeslag bij.'
        : basis + '. Je krijgt de definitieve all-in prijs in je voorstel.';
    } else {
      el('[data-vw-prijs-bedrag]').textContent = bedrag(per) + ' per m\u00b2';
      mini(bedrag(per) + ' p/m\u00b2');
      toel.textContent = 'Vul je oppervlakte in en je ziet direct het totaal.';
    }
  }

  function vulSamenvatting() {
    var v = vloerVan(state.vloer);
    var doelEl = el('[data-vw-samenvatting]');
    if (!doelEl) return;
    doelEl.style.display = v ? '' : 'none';
    vulPrijs();
    if (v) {
      el('[data-vw-sam-img]').src = v.img;
      el('[data-vw-sam-titel]').textContent = v.titel;
    }
    var regels = [];
    if (state.m2 > 0) regels.push(snijAan() ? '±' + m2Totaal() + ' m² vloer, incl. ' + snijPct() + '% snijverlies' : m2Totaal() + ' m² vloer');
    if (cfg.stappen.plinten && (state.plintKeuze || state.plintKleur || state.plinten)) regels.push(plintTekst() === 'Nee' ? 'Geen plinten' : 'Plinten: ' + plintTekst());
    if (ondergrondTekst()) regels.push(ondergrondTekst());
    if (cfg.samenvattingRegel) regels.push(cfg.samenvattingRegel);
    if (cfg.stappen.legservice && state.legservice) regels.push(state.legservice === 'ja' ? 'Geleverd én gelegd door Vloergigant' : 'Zelf leggen, met doe-het-zelfkorting');
    if (cfg.stappen.planning && state.planning) regels.push(state.planning + (state.plaats ? ' · ' + state.plaats : ''));
    el('[data-vw-sam-regels]').innerHTML = regels.map(function (r) { return '<li>' + r + '</li>'; }).join('');
  }

  /* ---- versturen ---- */
  function ondergrondTekst() {
    if (!cfg.stappen.ondergrond) return '';
    var d = [];
    if (state.vloerverwarming) d.push('Vloerverwarming: ' + state.vloerverwarming);
    if (state.ondervloer) d.push('Huidige vloer: ' + state.ondervloer);
    return d.join(' \u00b7 ');
  }

  function waTekst(nummer) {
    var v = vloerVan(state.vloer);
    var r = ['Hallo Vloergigant! Ik heb net mijn vloer samengesteld' + (nummer ? ' (aanvraag ' + nummer + ')' : '') + ':'];
    if (v) r.push('- Vloer: ' + v.titel + ' (' + patroonLabel() + ')');
    if (state.m2 > 0) r.push('- Oppervlakte: ' + m2Totaal() + ' m2' + (snijAan() ? ' (' + state.m2 + ' m2 + ' + snijPct() + '% snijverlies)' : ''));
    if (ondergrondTekst()) r.push('- Ondergrond: ' + ondergrondTekst());
    if (cfg.stappen.plinten && state.plinten) r.push('- Plinten: ' + plintTekst());
    if (cfg.stappen.legservice && state.legservice) r.push('- Leggen: ' + (state.legservice === 'ja' ? 'Ja, graag' : 'Nee, doe ik zelf'));
    if (cfg.stappen.planning && state.planning) r.push('- Planning: ' + state.planning);
    if (state.plaats) r.push('- Plaats: ' + state.plaats);
    if (state.wilPlattegrond || state.wilFotos) r.push('- Mijn plattegrond/foto’s stuur ik mee in deze chat');
    if (state.naam) r.push('Mijn naam is ' + state.naam + '. Ik ontvang graag jullie voorstel!');
    return r.join('\n');
  }

  function waLink(nummer) {
    return 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(waTekst(nummer));
  }

  function toonKlaar(nummer, viaWhatsapp) {
    var v = vloerVan(state.vloer);
    if (state.naam) el('[data-vw-klaar-naam]').textContent = 'Gelukt ' + state.naam.split(' ')[0] + ', we gaan voor je aan de slag!';
    el('[data-vw-klaar-nummer]').textContent = 'Aanvraag ' + nummer;
    if (v) {
      el('[data-vw-klaar-img]').src = v.img;
      el('[data-vw-klaar-titel]').textContent = v.titel + ' · ±' + m2Totaal() + ' m²';
    }
    var mini = el('.vw-mini');
    if (mini) mini.style.display = v ? '' : 'none';
    var wa = el('[data-vw-klaar-wa]');
    if (wa) {
      wa.href = waLink(nummer);
      if (viaWhatsapp) wa.textContent = 'Open WhatsApp opnieuw';
    }
    try { localStorage.removeItem(OPSLAG); } catch (e) {}
    toon(FLOW.length);
    meet('vw_verstuurd', { vw_kanaal: viaWhatsapp ? 'whatsapp' : 'email', vw_nummer: nummer });
  }

  function pseudoNummer() {
    return 'VG-' + Date.now().toString(36).toUpperCase().slice(-5);
  }

  function verstuurNatief() {
    // Volledig binnen Shopify: het ingebouwde contactformulier mailt het team.
    var nummer = pseudoNummer();
    var v = vloerVan(state.vloer);
    function zet(k, val) { var i = el('[data-vwf="' + k + '"]'); if (i) i.value = val || ''; }
    zet('email', state.email);
    zet('naam', state.naam);
    zet('telefoon', state.telefoon);
    zet('nummer', nummer);
    zet('vloer', v ? v.titel : '');
    zet('legpatroon', patroonLabel());
    zet('oppervlakte', m2Totaal() + ' m2' + (snijAan() ? ' (' + state.m2 + ' m2 ingevuld + ' + snijPct() + '% snijverlies)' : ' (zonder snijverlies)'));
    zet('ondergrond', ondergrondTekst());
    zet('plinten', plintTekst());
    zet('legservice', cfg.stappen.legservice ? (state.legservice === 'ja' ? 'Ja, geleverd en gelegd' : 'Nee, zelf leggen (doe-het-zelfkorting)') : '');
    zet('planning', state.planning || '');
    zet('plaats', state.plaats || '');
    zet('bijlagenInfo', (state.wilPlattegrond || state.wilFotos) ? 'Klant stuurt plattegrond/foto’s na via WhatsApp' : 'Geen');
    zet('body', 'Nieuwe vloer-aanvraag ' + nummer + (cfg.campagne ? ' voor ' + cfg.campagne : '') + ' via de Stel-je-vloer-samen wizard. Reageren binnen ' + cfg.uren + ' uur.');
    var qs = new URLSearchParams(location.search);
    var terug = new URLSearchParams();
    if (qs.get('view')) terug.set('view', qs.get('view'));
    terug.set('vw', 'verstuurd');
    terug.set('nr', nummer);
    zet('returnTo', location.pathname + '?' + terug.toString());
    state.nummer = nummer;
    bewaar();
    var f = document.getElementById('vw-contactform');
    if (f) {
      if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
        // Officiële Shopify-API: haalt het captcha-token op en roept daarna de callback aan.
        window.Shopify.captcha.protect(f, function () { f.submit(); });
      } else if (f.requestSubmit) {
        f.requestSubmit();
      } else {
        f.submit();
      }
    } else {
      window.open(waLink(nummer), '_blank');
      toonKlaar(nummer, true);
    }
  }

  function verstuur() {
    var knop = el('[data-step="contact"] [data-vw-volgende]');
    var viaMail = cfg.kanaal === 'email' || cfg.kanaal === 'beide';
    var viaEndpoint = viaMail && cfg.endpoint;

    if (viaMail && !viaEndpoint) {
      knop.disabled = true;
      knop.textContent = 'Versturen...';
      verstuurNatief();
      return;
    }

    if (!viaEndpoint) {
      var nummer = pseudoNummer();
      window.open(waLink(nummer), '_blank');
      toonKlaar(nummer, true);
      return;
    }

    var alleBijlagen = bijlagen.plattegrond.concat(bijlagen.fotos);
    var totaal = alleBijlagen.reduce(function (som, b) { return som + b.data.length; }, 0);
    while (totaal > MAX_TOTAAL_B64 && alleBijlagen.length) {
      totaal -= alleBijlagen.pop().data.length;
    }

    var v = vloerVan(state.vloer);
    var payload = {
      naam: state.naam, email: state.email, telefoon: state.telefoon,
      vloer: v ? v.titel : '', legpatroon: patroonLabel(),
      m2: state.m2, m2Totaal: m2Totaal(), snijverlies: snijAan() ? snijPct() : 0,
      plinten: plintTekst(),
      legservice: cfg.stappen.legservice ? (state.legservice === 'ja' ? 'Ja, geleverd en gelegd' : 'Nee, zelf leggen (doe-het-zelfkorting)') : '',
      ondergrond: ondergrondTekst(), actie: cfg.campagne || '',
      planning: state.planning || '', plaats: state.plaats || '',
      bijlagen: alleBijlagen, bedrijf: el('[name="vw-bedrijf"]') ? el('[name="vw-bedrijf"]').value : ''
    };

    knop.disabled = true;
    knop.textContent = 'Versturen...';

    fetch(cfg.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (res) {
        if (res && res.ok) {
          toonKlaar(res.nummer || pseudoNummer(), false);
        } else {
          throw new Error('endpoint');
        }
      })
      .catch(function () {
        knop.disabled = false;
        knop.textContent = 'Aanvraag versturen';
        fout('contact', 'Versturen lukte even niet. Probeer het opnieuw, of stuur je aanvraag direct via WhatsApp:');
        var fallback = el('[data-vw-wa-fallback]');
        if (fallback) { fallback.style.display = 'block'; fallback.href = waLink(''); }
      });
  }

  /* ---- init ---- */
  togglePlintVelden();
  var qp = new URLSearchParams(location.search);
  if (qp.get('vw') === 'verstuurd' || qp.get('contact_posted') === 'true') {
    toonKlaar(qp.get('nr') || state.nummer || pseudoNummer(), false);
    try { history.replaceState(null, '', location.pathname); } catch (e) {}
  } else {
    toon(-1);
  }
})();
